import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Auth0Provider } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from './contexts/SnackbarContext';
import { GlobalSnackbar } from './components/GlobalSnackbar';
import { getConfig } from '@/config';
const AuthProvider = () => {
    const { showError } = useSnackbar();
    const { i18n } = useTranslation();
    const config = getConfig();
    const navigate = useNavigate();
    useEffect(() => {
        if (!config.REACT_APP_API_URL) {
            showError('REACT_APP_API_URL undefined');
        }
        if (!config.REACT_APP_AUTH0_CLIENT_ID) {
            showError('REACT_APP_AUTH0_CLIENT_ID undefined');
        }
        if (!config.REACT_APP_AUTH0_DOMAIN) {
            showError('REACT_APP_AUTH0_DOMAIN undefined');
        }
        if (!config.REACT_APP_AUTH0_AUDIENCE) {
            showError('REACT_APP_AUTH0_AUDIENCE undefined');
        }
    }, [config, showError]);
    return (_jsxs(Auth0Provider, { useRefreshTokens: true, cacheLocation: "localstorage", domain: config.REACT_APP_AUTH0_DOMAIN, clientId: config.REACT_APP_AUTH0_CLIENT_ID, authorizationParams: {
            audience: config.REACT_APP_AUTH0_AUDIENCE,
            redirect_uri: window.location.origin,
            scope: `email openid offline_access profile
          read:current_user
          read:roles
          update:current_user_metadata`,
            ui_locales: i18n.language,
        }, onRedirectCallback: appState => navigate(appState?.returnTo || window.location.pathname), children: [_jsx(Outlet, {}), _jsx(GlobalSnackbar, {})] }));
};
export default AuthProvider;
